import request from '@/utils/request'

export function getUnreadMessages() {
  return request({
    url: '/msg/message/unread/all',
    method: 'get'
  })
}

export function getUnreadMessagesByBizType(bizType) {
  return request({
    url: `/msg/message/unread/${bizType}`,
    method: 'get'
  })
}

// 修改这个函数，移除userId参数
export function markAsRead(messageId) {
  return request({
    url: '/msg/message/mark-read',
    method: 'put',
    params: {
      messageId
    }
  })
}

export function markAllAsRead() {
  return request({
    url: '/msg/message/mark-read/all',
    method: 'put'
  })
}

export function markAllAsReadByBizType(bizType) {
  return request({
    url: `/msg/message/mark-read/all/${bizType}`,
    method: 'put'
  })
}

export function deleteAllMessagesForUser(userId) {
  return request({
    url: `/msg/message/user/${userId}`,
    method: 'delete'
  })
}

export function getMessageById(id) {
  return request({
    url: `/msg/message/${id}`,
    method: 'get'
  })
}

export function deleteMessage(id) {
  return request({
    url: `/msg/message/${id}`,
    method: 'delete'
  })
}

export function deleteBatch(ids) {
  return request({
    url: '/msg/message',
    method: 'delete',
    params: {
      'ids[]': ids
    },
    paramsSerializer: {
      serialize: function(params) {
        return params['ids[]'].map(id => `ids[]=${id}`).join('&')
      }
    }
  })
}

export function getUnreadMessageCount() {
  return request({
    url: '/msg/message/unread/all/count',
    method: 'get'
  })
}

export function getUnreadMessageCountByBizType(bizType) {
  return request({
    url: `/msg/message/unread/${bizType}/count`,
    method: 'get'
  })
}

export function getMessagePage(params) {
  return request({
    url: '/msg/message/page/user',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/msg/message.js